<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 500px; max-width: 80vw;':''">
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        تغییر ثبت کننده سفارش
        <template v-slot:action>
          <q-btn round icon="close" flat dense v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-select
          :dense="$q.screen.lt.md"
          filled
          v-model="selectedUser"
          label="ثبت کننده"
          :options="usersList"
          option-label="UserName"
          option-value="Users_ID"
          :rules="[requireRole]"
      >
        <template v-slot:no-option>
          <q-item>
            <q-item-section class="text-grey">
              بدون نتیجه
            </q-item-section>
          </q-item>
        </template>
      </q-select>
    </q-card-section>
    <q-card-actions align="center">
      <q-btn label="تایید" color="indigo" @click="updateInfo" text-color="white" icon="check" v-close-popup/>
      <q-btn label="انصراف" color="red" flat icon="cancel" v-close-popup/>
    </q-card-actions>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "ChangeOrderUser",
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      usersList: [],
      selectedUser: null
    }
  },
  computed: {
    currentUser: function () {
      return this.user
    }
  },
  methods: {
    ...mapActions({
      getUsersList: 'Users/getUsersByRolesIfActive',
      getUsersByRolesList:'Users/getUsersByRolesListIfActive',
      update: 'Orders/updateOrderUser'
    }),
    updateInfo() {
      this.update({
        saleNum: this.user.Sale_Num,
        userId: this.selectedUser.Users_ID
      }).then((res) => {
        if (res===1){
          this.user.UserName = this.selectedUser.UserName
          this.user.Sale_UserID = this.selectedUser.Users_ID
        }
      })
    },
    requireRole(val) {
      if (val === null || val === undefined || val === '') {
        return 'انتخاب الزامی است'
      }
    },
  },
  created() {
    this.getUsersByRolesList(['user_sell','user_visitor','visitor_without_area_limit']).then((res) => {
      this.usersList = res.filter(item => item.Auth)
      this.selectedUser = this.usersList.filter(item => item.Users_ID === this.user.Sale_UserID)[0]
    })
  }
}
</script>

<style scoped>

</style>